module.exports = __webpack_public_path__ + "static/media/ss8.41661aff.jpg";